import { createFileRoute, Link } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";

const STRIPE_PAYMENT_URL = "https://buy.stripe.com/14A4gy12K2WM0ZS8uD6c00q";

export const Route = createFileRoute("/placilo-najemnine")({
  head: () => ({
    meta: [
      { title: "Plačilo letne najemnine — kupish.si" },
      { name: "description", content: "Plačilo letne najemnine spletne trgovine na kupish.si (240 € letno). Novi prodajalci imajo prve 3 mesece brezplačno, plačilo je potrebno šele po izteku." },
      { property: "og:title", content: "Plačilo letne najemnine — kupish.si" },
      { property: "og:description", content: "Letna najemnina spletne trgovine na kupish.si znaša 240 €. Novi prodajalci imajo 3 mesece brezplačno." },
      { property: "og:url", content: "https://kupish.si/placilo-najemnine" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "sl_SI" },
      { property: "og:site_name", content: "kupish.si" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://kupish.si/placilo-najemnine" }],
  }),

  component: Page,
});

function Page() {
  const { user } = useAuth();
  const email = user?.email;
  const href = email
    ? `${STRIPE_PAYMENT_URL}?prefilled_email=${encodeURIComponent(email)}`
    : STRIPE_PAYMENT_URL;

  return (
    <article className="mx-auto max-w-2xl px-6 py-24 text-center">
      <div className="eyebrow">Za prodajalce</div>
      <h1 className="font-serif text-5xl mt-3">
        Plačilo letne <span className=" text-accent">najemnine</span>
      </h1>
      <p className="mt-6 text-lg text-muted-foreground">
        Najem spletne trgovine stane <strong className="text-foreground">240 € letno</strong>.
        Novo prijavljeni prodajalci imajo prve <strong className="text-foreground">3 mesece brezplačno</strong>,
        prodajalci, prijavljeni pred uvedbo teh pogojev, pa <strong className="text-foreground">6 mesecev</strong>.
        Plačilo je potrebno šele po izteku brezplačnega obdobja.
      </p>
      <p className="mt-3 text-muted-foreground">
        Po prejemu plačila se najem podaljša za eno leto, trgovina pa ostane objavljena brez prekinitve.
      </p>

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-10 inline-block px-10 py-4 bg-accent text-accent-foreground rounded font-medium text-lg hover:opacity-90 transition-opacity"
      >
        Plačaj preko Stripe →
      </a>

      <p className="mt-4 text-sm text-muted-foreground">
        Pri plačilu vnesite isti e-naslov, s katerim ste registrirani na kupish.si — tako se najem pripiše vaši trgovini.
      </p>


      <p className="mt-12 text-sm text-muted-foreground">
        Vprašanja glede plačila? <Link to="/o-nas" className="text-accent">Kontaktirajte nas</Link>.
      </p>
    </article>
  );
}
